import {useMutation} from '@apollo/client';
import {message} from 'antd';
import {useTranslation} from 'react-i18next';
import {showError} from '../../../../utils/exceptionUtils';
import {
    SUBMIT_POD_RISK_REVIEW_ACTION,
    SubmitPodRiskReviewActionResponse
} from '../graphql/mutations/podRiskReviewMutations';
import {PodRiskReviewAction} from '../graphql/types/PodRiskReviewType';

/**
 * 舆情 POD 审核提交（一次一单，批量由调用方循环调用）
 *
 * 审核员不由前端传，后端取当前登录账号以防伪造审核人。
 */
export const usePodRiskReviewActions = () => {
    const {t} = useTranslation();
    const [submitAction, {loading}] = useMutation<SubmitPodRiskReviewActionResponse>(
        SUBMIT_POD_RISK_REVIEW_ACTION
    );

    const handleReview = async (
        reviewTaskId: string,
        action: PodRiskReviewAction,
        riskTypeCodes?: string[],
        reviewRemark?: string,
        reviewRemarkLang?: string
    ): Promise<boolean> => {
        // 判定「存在舆情风险」必须给出类型，否则后端会拒绝；此处前置拦截以免无效请求
        if (action === PodRiskReviewAction.REJECT && !riskTypeCodes?.length) {
            message.error(t('podRiskReview.messages.riskTypeRequired'));
            return false;
        }

        try {
            const {data} = await submitAction({
                variables: {
                    reviewTaskId,
                    action,
                    riskTypeCodes: riskTypeCodes?.length ? riskTypeCodes : null,
                    reviewRemark: reviewRemark || null,
                    // 无备注时不必传语种（后端仅在有备注时构造富化 JSON）
                    reviewRemarkLang: reviewRemark ? reviewRemarkLang || null : null
                }
            });

            if (data?.submitPodRiskReviewAction) {
                const actionText =
                    action === PodRiskReviewAction.APPROVE
                        ? t('podRiskReview.messages.approved')
                        : t('podRiskReview.messages.rejected');
                message.success(t('podRiskReview.messages.reviewSuccess', {action: actionText}));
                return true;
            }

            message.error(t('podRiskReview.messages.reviewFailed'));
            return false;
        } catch (error) {
            showError(error);
            return false;
        }
    };

    return {
        handleReview,
        loading
    };
};
